<template>
    <b-container>
        <b-form v-on:submit.prevent="connect">
            <h1>Bienvenue sur OpenRaideur</h1>
            <b-alert :show="loginError" variant="danger">Erreur d'authentification ! Vérifiez votre login et votre mot de passe.</b-alert>

            <h3>Connexion</h3>
            <b-form-group
            id="input-group-1"
            label="Nom d'utilisateur"
            label-for="input-1"
            >
                <b-form-input
                    id="input-1"
                    v-model="username"
                    required
                    placeholder="pdupond"
                ></b-form-input>
            </b-form-group>

            <b-form-group
            id="input-group-2"
            label="Mot de passe"
            label-for="input-2"
            >
                <b-form-input
                    id="input-2"
                    v-model="password"
                    required
                    type="password"
                ></b-form-input>
            </b-form-group>
            <b-button type="submit" variant="success">Se connecter</b-button>
        </b-form>
        <hr>
        <h3>Mode</h3>
        <b-link href="/">Basculer vers le mode classique</b-link>
        <br>
        <b-link href="/gps">Basculer vers le mode conducteurs</b-link>

    </b-container>
</template>

<script>
const axios = require('axios').default;

export default {
    name: 'Login',
    data() {
        return {
            username: "",
            password: "",
            loginError: false
        }
    },
    methods: {
        async connect() {
            await axios.post('/api/auth/', {
                username: this.username,
                password: this.password
            })
                .then(response => {
                    this.loginError = false;

                    const access_token = response.data.access;
                    const refresh_token = response.data.refresh;
                    const username = response.data.username;
                    const year = response.data.year;
                    const external_user = response.data.external_user;

                    localStorage.setItem('access_token', access_token)
                    localStorage.setItem('refresh_token', refresh_token)
                    localStorage.setItem('username', username)
                    localStorage.setItem('year', year)
                    localStorage.setItem('external_user', external_user)
                    
                    if (external_user) {
                        alert("Les informations contenues sur ce site sont strictement confidentielles. Elles ne doivent pas être diffusées, sous quelque forme que ce soit, sans l'accord écrit du BdE INSA Lyon.");
                    }
                    
                    this.$router.push(this.$router.history.current.query.next);
                })
                .catch(error => {
                    console.log("Erreur auth !" + error);
                    this.loginError = true;
                    this.username = "";
                    this.password = "";
            })
        }
    }
}
</script>

<style>

</style>